import { render, staticRenderFns } from "./ViewPublicJobDetails.vue?vue&type=template&id=dcebc4a8&scoped=true"
import script from "./ViewPublicJobDetails.vue?vue&type=script&lang=ts"
export * from "./ViewPublicJobDetails.vue?vue&type=script&lang=ts"
import style0 from "./ViewPublicJobDetails.vue?vue&type=style&index=0&id=dcebc4a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcebc4a8",
  null
  
)

export default component.exports